import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "results", "activityType", "activityId", "currentActivity", "searchContainer"]
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  searchInputTargetConnected() {
    this.searchInputTarget.addEventListener('input', this.handleInput.bind(this))
    this.searchInputTarget.addEventListener('focus', this.handleInput.bind(this))
  }

  handleInput(event) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const query = this.searchInputTarget.value.trim()

    if (query.length < 2) {
      this.clearResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.search(query)
    }, 300)
  }

  async search(query) {
    try {
      const url = `${this.urlValue}?query=${encodeURIComponent(query)}`
      const response = await fetch(url)
      const results = await response.json()

      this.displayResults(results)
    } catch (error) {
      console.error('Search error:', error)
      this.clearResults()
    }
  }

  displayResults(results) {
    this.resultsTarget.innerHTML = ''

    if (results.length === 0) {
      this.resultsTarget.innerHTML = '<div class="list-group-item text-muted">No results found</div>'
      return
    }

    results.forEach(result => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'list-group-item list-group-item-action'
      item.innerHTML = `
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <strong>${this.escapeHtml(result.name)}</strong>
            <br>
            <small class="text-muted">${result.type}</small>
          </div>
        </div>
      `
      item.addEventListener('click', () => this.selectResult(result))
      this.resultsTarget.appendChild(item)
    })
  }

  selectResult(result) {
    this.activityTypeTarget.value = result.type
    this.activityIdTarget.value = result.id

    // Update the display
    if (this.hasCurrentActivityTarget) {
      this.currentActivityTarget.querySelector('strong').textContent = result.name
      this.currentActivityTarget.querySelector('small').textContent = `Type: ${result.type} | ID: ${result.id}`
      this.currentActivityTarget.style.display = 'flex'
    }

    // Hide search container
    this.searchContainerTarget.style.display = 'none'

    // Clear search
    this.searchInputTarget.value = ''
    this.clearResults()
  }

  clearSelection(event) {
    event.preventDefault()

    this.activityTypeTarget.value = ''
    this.activityIdTarget.value = ''

    if (this.hasCurrentActivityTarget) {
      this.currentActivityTarget.style.display = 'none'
    }

    this.searchContainerTarget.style.display = 'block'
    this.searchInputTarget.focus()
  }

  clearResults() {
    this.resultsTarget.innerHTML = ''
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
